<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!purchasesInvoice">
      <span class="loader"></span>
    </span>
    <purchases-invoice-form
      v-if="purchasesInvoice"
      :loading="loading"
      :purchasesInvoiceData="purchasesInvoice"
      :formErrors="formErrors"
      @purchasesInvoiceSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import PurchasesInvoiceForm from "../partials/PurchasesInvoiceForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";

export default {
  layout: "DashboardLayout",

  components: { PurchasesInvoiceForm },

  mixins: [alertLeave],

  props: {
    purchasesInvoiceId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      purchasesInvoice: null,
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch(
          "purchasesInvoices/get",
          this.purchasesInvoiceId
        );
        this.purchasesInvoice =
          this.$store.getters["purchasesInvoices/purchasesInvoice"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    async handleSubmit(purchasesInvoice) {
      this.loading = true;
      const purchasesInvoiceData = cloneDeep(purchasesInvoice);
      try {
        await this.$store.dispatch(
          "purchasesInvoices/update",
          purchasesInvoiceData
        );
        this.$notify({
          type: "success",
          message: this.$t("PURCHASES_INVOICES.PURCHASES_INVOICE_UPDATED"),
        });
        const purchasesInvoice = await this.$store.getters[
          "purchasesInvoices/purchasesInvoice"
        ];
        this.$emit("onViewPurchasesInvoice", purchasesInvoice, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
